/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ credits: NonNullable<unknown> }} Aiflowstartsubmit3Inputs */

const en_aiflowstartsubmit3 = /** @type {(inputs: Aiflowstartsubmit3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fill in for ${i?.credits} credits`)
};

const de_aiflowstartsubmit3 = /** @type {(inputs: Aiflowstartsubmit3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ausfüllen für ${i?.credits} Credits`)
};

/**
* | output |
* | --- |
* | "Fill in for {credits} credits" |
*
* @param {Aiflowstartsubmit3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowstartsubmit3 = /** @type {((inputs: Aiflowstartsubmit3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowstartsubmit3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowstartsubmit3(inputs)
	return de_aiflowstartsubmit3(inputs)
});
export { aiflowstartsubmit3 as "aiFlowStartSubmit" }